import AdminMainPanel from '../Layouts/AdminMainPanel';
import NavBar from '../Layouts/NavBar';
import DiffList from './DiffList';

const EnvDiff = () => {
    return (
        <div className="environments">
            <AdminMainPanel>
                <NavBar className={'environments-panel'} />
                <div className="admin-main-content environments-panel">
                    <h3 className="title">Environments Comparison</h3>
                    <p className="desc">
                        Use this to promote changes to pages, components, and assets from one
                        environment to another. Select source env and destination env to compare and
                        merge.
                    </p>
                    <DiffList />
                </div>
            </AdminMainPanel>
        </div>
    );
};

export default EnvDiff;
